import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { CreateQuoteApiResultModel } from "@WhiteCap/Store/Service/OsnQuotes/OsnQuotesApiModels";
import { createQuoteService } from "@WhiteCap/Store/Service/OsnQuotes/OsnQuotesServices";

export interface CreateQuoteApiParameter extends ApiParameter {
    branchContactId: string;
    shipToId: string;
    billToId: string;
    warehouseId: string;
    shippingMethodCode: string;
    quoteName: string;
    quoteRequestedDate: string;
    poNumber: string;
    quoteExpiryDate: string;
    salesRepEmail: string;
    billToFirstName: string;
    billToLastName: string;
    shipToFirstName: string;
    shipToLastName: string;
    subtotal: number;
    quoteLineCollection: QuoteLineCollectionApiParameter[];
    onError?: (error: string) => void;
    onSuccess?: (quoteNumber: string) => void;
}

export interface QuoteLineCollectionApiParameter {
    productId: string;
    productNumber: string;
    qty: number;
    quotePrice: number;
    listPrice: number;
}
type HandlerType = CustomApiHandler<CreateQuoteApiParameter, CreateQuoteApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/OsnQuote/BeginSubmitCreateQuote",
    });
};

export const MakeApiRequest: HandlerType = async props => {
    const result = await createQuoteService(
        props.apiParameter.branchContactId,
        props.apiParameter.shipToId,
        props.apiParameter.billToId,
        props.apiParameter.warehouseId,
        props.apiParameter.shippingMethodCode,
        props.apiParameter.quoteName,
        props.apiParameter.quoteRequestedDate,
        props.apiParameter.poNumber,
        props.apiParameter.quoteExpiryDate,
        props.apiParameter.salesRepEmail,
        props.apiParameter.billToFirstName,
        props.apiParameter.billToLastName,
        props.apiParameter.shipToFirstName,
        props.apiParameter.shipToLastName,
        props.apiParameter.subtotal,
        props.apiParameter.quoteLineCollection,
    );
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if (props.apiParameter?.onSuccess) {
            props.apiParameter.onSuccess(result.result.quoteNumber);
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/OsnQuote/CreateQuoteSubmitError",
        });
        return false;
    }
};

export const DispatchCompleteApplyPodSubscriptions: HandlerType = props => {
    props.dispatch({
        type: "Custom/OsnQuote/CompleteSubmitCreateQuote",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, MakeApiRequest, DispatchCompleteApplyPodSubscriptions];

const osnCreateQuote = createHandlerChainRunner(chain, "OsnCreateQuote");
export default osnCreateQuote;
